import { Card, CardBody, Col } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { PaddingTitle } from "../../../../Constants/Constants";
import { PaddingList, PaddingSubTitle } from "../../../../Data/UiKits/HelperClasses";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const Padding = () => {
  return (
    <Col xl="12">
      <Card>
        <CommonCardHeader title={PaddingTitle} span={PaddingSubTitle} />
        <CardBody>
          <div className="border-wrapper h-100 alert-light-light dark-helper">
            <H6 className="mb-3">{PaddingTitle}</H6>
            <div className="helper-common-box helper-p-wrapper">
              {PaddingList.map((item, index) => (
                <div key={index} className={`helper-p-box p-${item} bg-light border`}>
                  <span>{`.p-${item}`}</span>
                </div>
              ))}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default Padding;
